module.exports = __webpack_public_path__ + "static/img/1029.be5dae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1029.png
// module id = 7BR8
// module chunks = 1